<template>
  <div>
    <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
      Completá y cargá la factura
    </h6>
    <p
      class="text-subtitle-2 text-md-subtitle-1 font-weight-regular grey--text text--darken-1"
    >
      Subí la factura completa con los siguientes items e importes, podés copiar
      estos datos y pegarlos directamente en la factura que estes completando.
    </p>

    <InvoiceList :items="formData.transactions" />

    <div class="mb-10" v-if="formData?.invoice != null">
      <UploadedInvoice
        :invoice="formData.invoice"
        canRemove
        :disableDeleteButton="isValidatingInvoice"
      />
    </div>

    <div v-else>
      <input
        accept="application/pdf"
        type="file"
        class="d-none"
        ref="imageUploader"
        @change="handleChange"
      />

      <v-btn
        type="button"
        large
        @click="handleClick"
        block
        class="blue darken-2 white--text mb-4"
        :loading="validationStatus === 'loading'"
      >
        <v-icon>attach_file</v-icon> subir factura
      </v-btn>

      <p
        v-if="invoiceErrors?.length"
        class="subtitle-1 red--text darken-4 font-weight-medium"
      >
        {{ invoiceErrors[0] }}
      </p>
    </div>

    <v-dialog v-model="showAlertDialog" persistent max-width="450">
      <v-card flat class="pa-4 d-flex flex-column" style="gap: 1.5rem">
        <div class="d-flex align-start" style="gap: 0.75rem">
          <v-icon
            :size="$vuetify.breakpoint.mdAndUp ? '32' : '28'"
            :color="iconColor"
            >{{ icon }}</v-icon
          >
          <div class="d-flex flex-column flex-grow-1">
            <v-card-title class="pa-0">
              <span class="text-subtitle-1 text-md-h6 font-weight-bold">{{
                alertTitle
              }}</span>
            </v-card-title>
            <v-card-text class="pa-0">
              <span
                class="text-body-2 text-md-subtitle-1 font-weight-regular grey--text text--darken-1"
                v-html="alertContent"
              />
            </v-card-text>
          </div>
        </div>
        <v-card-actions class="pa-0 d-flex justify-end">
          <v-btn
            :block="$vuetify.breakpoint.smAndDown"
            :color="alertButtonColor"
            @click="closeAlertDialog"
          >
            <span class="font-weight-bold white--text text-caption">{{
              alertButtonText
            }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import InvoiceList from "../InvoiceList.vue";
import UploadedInvoice from "../UploadedInvoice.vue";
import { createAlert, createErrorAlert } from "@/helpers/alerts";

export default {
  name: "InvoiceValidationStep",
  props: ["formData", "v", "isValidatingInvoice"],
  components: {
    InvoiceList,
    UploadedInvoice,
  },
  data: () => ({
    file: [],
    showAlertDialog: false,
    alertTitle: "",
    alertContent: "",
    icon: "",
    iconColor: "",
    alertButtonText: "",
    alertButtonColor: "",
  }),
  computed: {
    ...mapState("invoice", ["validationStatus"]),

    invoiceErrors() {
      const errors = [];
      if (!this.v.invoice.$error) return errors;
      !this.v.invoice.required && errors.push("Debe cargar un archivo");
      return errors;
    },
  },
  methods: {
    ...mapActions("invoice", ["setInvoiceFile"]),

    openAlertDialog(options) {
      const alert =
        typeof options === "string"
          ? createErrorAlert(options)
          : options.type
          ? createAlert(options)
          : createErrorAlert(options);

      this.alertTitle = alert.title;
      this.alertContent = alert.content;
      this.icon = alert.icon;
      this.iconColor = alert.iconColor;
      this.alertButtonText = alert.buttonText;
      this.alertButtonColor = alert.buttonColor;
      this.showAlertDialog = true;
    },

    closeAlertDialog() {
      this.showAlertDialog = false;
    },

    handleClick() {
      this.$refs.imageUploader?.click();
    },

    handleChange() {
      this.file = this.$refs.imageUploader?.files[0];
      if (this.file == null) return;

      if (!this.file.name.toLowerCase().endsWith(".pdf")) {
        this.openAlertDialog({
          title: "Formato no compatible",
          message: "Solo se admiten archivos <strong>PDF</strong>.",
        });
        this.file = null;
        return;
      }

      this.setInvoiceFile(this.file);

      this.$emit("validateInvoice", this.file);

    },
  },
};
</script>

<style></style>
